'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/Trophy.es.js";
const r = a.forwardRef((e$1, t) => /* @__PURE__ */ a.createElement(p, { ref: t, ...e$1, weights: e }));
r.displayName = "TrophyIcon";
const s = r;
export {
  s as Trophy,
  r as TrophyIcon
};
